const initialState = () => ({selectedLabels: []});

export default {
	namespaced: true,

	state: initialState(),

	mutations: {
		resetGlobalLabelsState,
		addLabel,
		removeLabel
	},
};

function resetGlobalLabelsState(state) {
	Object.assign(state, initialState());
}

function addLabel(state, label) {
	const alreadyAdded = state.selectedLabels
		.some(selectedLabel => selectedLabel.label_id === label.label_id);

	// don't add the same label
	if (alreadyAdded)
		return;


	state.selectedLabels = [ ...state.selectedLabels, label ];
}

function removeLabel(state, labelId) {
	state.selectedLabels = state.selectedLabels
		.filter(selectedLabel => selectedLabel.label_id !== labelId);
}
